<template>
    <section class="videosection">
        <a @click="$router.back()" class="closeBtns">
            <span class="icon">
                <i class="far fa-times-circle"></i>
            </span>
        </a>
        <div class="video-container" v-if="screen === 0">
            <video-player v-if="vid1.loaded" class="vjs-custom-skin" ref="videoPlayer" :options="vid1"
                :playsinline="true" @ended="onPlayerEnded($event)"></video-player>
            <div class="videoBtns">
                <a class="button is-small" id="skipBtn" @click="screen = 1">
                    <span>Build It</span>
                    <span class="icon">
                        <i class="fas fa-chevron-right"></i>
                    </span>
                </a>
            </div>
            <div v-if="popupOpen" class="cartoon2 is-hidden-desktop">
                <div class="columns">
                    <div class="column">
                        <div class="scard">
                            <h1 class="title">
                                Would you like to complete
                                <b>"{{ name }}"</b>?
                            </h1>
                            <div class="columns">
                                <div class="column has-text-centered">
                                    <img src="@/assets/img/coin.svg" alt />
                                    <h3 class="subtitle">
                                        Build &amp; Win
                                        {{ coins }} coins.
                                    </h3>
                                </div>
                            </div>
                            <button class="btn btn-theme" @click="screen = 1">Yes</button>
                            <a class="btn btn-theme" @click="router('/')">No</a>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <img src="@/assets/img/cartoon.png" class="cartoonImg" />
                    </div>
                </div>
            </div>
            <div class="cartoon2 is-hidden-touch">
                <div class="columns">
                    <div class="column">
                        <div class="scard">
                            <h1 class="title">
                                Would you like to complete
                                <b>"{{ name }}"</b>?
                            </h1>
                            <div class="columns">
                                <div class="column has-text-centered">
                                    <img src="@/assets/img/coin.svg" alt />
                                    <h3 class="subtitle">
                                        Build &amp; Win
                                        {{ coins }} coins.
                                    </h3>
                                </div>
                            </div>
                            <button class="btn btn-theme" @click="screen = 1">Yes</button>
                            <a class="btn btn-theme" @click="router('/')">No</a>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <img src="@/assets/img/cartoon.png" class="cartoonImg" />
                    </div>
                </div>
            </div>
        </div>
        <div class="video-container" v-else-if="screen === 1">
            <img :src="banner" class="featuredImg desktop-video" />
            <div class="hero desktop-video-info">
                <div class="hero-body">
                    <h1 class="title">{{ name }}</h1>
                    <!-- <a class="button is-fullwidth" @click="shareDialog">
            <span class="icon">
              <i class="fas fa-share-alt"></i>
            </span>
            <span>Share with Friends</span>
          </a> -->
                    <div class="separator">MORE INFO</div>
                    <h3 class="subtitle">To build this project, you will need:</h3>
                    <section class="section nkitinfo">
                        <!-- Main Components -->
                        <div class="parts-list">
                            <div v-for="(component, index) in components" :key="'nkit' + index" class="part-card">
                                <div class="part-image">
                                    <img :src="component.image" :alt="component.name" />
                                </div>
                                <div class="part-details">
                                    <div class="part-header">
                                        <h3 class="part-name">{{ component.name }}</h3>
                                        <button class="cart-toggle-btn" 
                                            :class="{ 'in-cart': isInCart(component.shopify_data?.variant_id) }"
                                            @click="checkAuthAndProceed(() => toggleCart(component))">
                                            <svg v-if="isInCart(component.shopify_data?.variant_id)" class="check-icon" width="20" height="20"
                                                viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <svg v-else class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 4.16666V15.8333M4.16669 10H15.8334" stroke="white" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                    <p v-if="component.shopify_data?.price" class="part-price">₹{{ component.shopify_data.price }} per unit</p>
                                    <div class="part-quantity">× {{ component.qty }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Alternative Components -->
                        <div v-if="altComponents.length > 0" class="alt-components">
                            <div class="separator">OR</div>
                            <div class="parts-list">
                                <div v-for="(component, index) in altComponents" :key="'alt-' + index" class="part-card">
                                    <div class="part-image">
                                        <img :src="component.image" :alt="component.name" />
                                    </div>
                                    <div class="part-details">
                                        <div class="part-header">
                                            <h3 class="part-name">{{ component.name }}</h3>
                                            <button class="cart-toggle-btn"
                                                :class="{ 'in-cart': isInCart(component.shopify_data?.variant_id) }"
                                                @click="checkAuthAndProceed(() => toggleCart(component))">
                                                <svg v-if="isInCart(component.shopify_data?.variant_id)" class="check-icon" width="20"
                                                    height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <svg v-else class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 4.16666V15.8333M4.16669 10H15.8334" stroke="white" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                        <p v-if="component.shopify_data?.price" class="part-price">₹{{ component.shopify_data.price }} per unit</p>
                                        <div class="part-quantity">× {{ component.qty }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="trailerVidBtn">
                        <div class="columns">
                            <div class="column" style="padding-top: 0px">
                                <a v-if="shopifyCartCheck.length > 0" class="button btn btn-theme" @click="checkAuthAndProceed(openCart)"
                                    target="blank">
                                    Go to cart
                                </a>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column" style="padding-top: 0px">
                                <button @click="checkAuthAndProceed(markComplete)" v-bind:class="{ 'is-loading': btnLoading }"
                                    class="button btn btn-theme">
                                    Mark Complete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a @click="screen = 0" class="screen2Btn">
                <span class="icon">
                    <i class="fas fa-chevron-circle-left"></i>
                </span>
            </a>
        </div>
        <div style="padding: 20px" v-else-if="screen === 2">
            <img src="@/assets/img/congrats.svg" class="congrats" />
            <h1 class="title has-text-centered" style="padding-bottom: 15px">
                Congratulations!
            </h1>
            <h3 class="subtitle has-text-centered">
                Upload your project's video to win
                <b style="color: #000000">{{ coins }} coins.</b>
            </h3>
            <a @click="checkAuthAndProceed(() => router('/upload/challenge/' + $route.params.id + '/' + coins))" class="btn btn-theme">Upload
                Video</a>
            <a @click="screen = 1" class="screen3Btn">
                <span class="icon">
                    <i class="fas fa-chevron-circle-left"></i>
                </span>
            </a>
        </div>
    </section>
</template>
<script>
// import { Plugins } from "@capacitor/core";
import { auth } from "@/main.js";
import { functions } from "@/main.js";
import { db } from "@/main.js";
import { firestore } from "@/main.js";
// const { Browser } = Plugins;
import { Share } from "@capacitor/share";
import { Browser } from "@capacitor/browser";
import "@/assets/css/video-js.css";
import { videoPlayer } from "vue-video-player";
// import { Webengage } from "@ionic-native/webengage";
import { createWebengageEvent } from "../helper";
export default {
    name: "challenge",
    components: {
        videoPlayer,
    },
    data() {
        return {
            userId: "",
            screen: 0,
            name: "",
            orderLink: "",
            coins: "",
            banner: "",
            popupOpen: false,
            components: [],
            altComponents: [],
            btnLoading: false,
            shop_link: "",
            vid1: {
                height: "100%",
                width: "100%",
                autoplay: true,
                muted: false,
                language: "en",
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [],
                poster: "",
                loaded: false,
            },
            cart: [],
            shopifyCart: [],
            shopifyCartCheck: [],
            activePlayerInstance: null,
            currentOrientation: '',
        };
    },
    beforeMount() {
        this.checkAuth();
        
        db.collection("config")
            .doc("categories")
            .get()
            .then((doc) => {
                this.shop_link = doc.data().challenge_shop;
            });
        
        db.collection("challenges")
            .doc(this.$route.params.id)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    // Track challenge view only if user is logged in
                    if (auth.currentUser) {
                        this.userId = auth.currentUser.uid;
                        createWebengageEvent({
                            uid: this.userId,
                            eventName: "Challenge Viewed",
                            eventData: {
                                added: new Date().getTime(),
                                readableDate: new Date().toLocaleString(),
                                name: doc.data().name,
                            },
                        });
                    }
                    
                    this.vid1.sources.push({ type: "video/mp4", src: doc.data().video });
                    this.vid1.poster =
                        "https://thumbnails.cloud/v1/jpg?token=16BcfdRyI2BfW1Rux&url=" +
                        encodeURIComponent(doc.data().video) +
                        "&size=400&mode=orig";
                    this.name = doc.data().name;
                    this.coins = doc.data().coins;
                    
                    // Apply premium bonus only if user is logged in and has premium
                    if (auth.currentUser && this.$store.state.profile.premium) {
                        this.coins = doc.data().coins * 2;
                    }
                    
                    this.orderLink = doc.data().orderLink;
                    this.banner = doc.data().featuredImg;
                    
                    // Fetch main components
                    const componentPromises = doc.data().components.map(componentId => 
                        db.collection("tools").doc(componentId).get()
                    );
                    
                    Promise.all(componentPromises).then(componentDocs => {
                        this.components = componentDocs.map(doc => {
                            if (!doc.exists) return null;
                            const data = doc.data();
                            return {
                                name: data.name,
                                link: data.orderLink,
                                video: data.video,
                                image: data.img,
                                pid: data.pid,
                                sid: data['shopify-id'] || '',
                                qty: 1, // Default quantity
                                shopify_data: data.shopify_data
                            };
                        }).filter(Boolean);
                    });

                    // Fetch alternative components
                    if (doc.data().altComponents && doc.data().altComponents.length > 0) {
                        const altComponentPromises = doc.data().altComponents.map(componentId =>
                            db.collection("tools").doc(componentId).get()
                        );
                        
                        Promise.all(altComponentPromises).then(componentDocs => {
                            this.altComponents = componentDocs.map(doc => {
                                if (!doc.exists) return null;
                                const data = doc.data();
                                return {
                                    name: data.name,
                                    link: data.orderLink,
                                    video: data.video,
                                    image: data.img,
                                    pid: data.pid,
                                    sid: data['shopify-id'] || '',
                                    qty: 1, // Default quantity
                                    shopify_data: data.shopify_data
                                };
                            }).filter(Boolean);
                        });
                    }

                    setTimeout(() => {
                        this.vid1.loaded = true;
                    }, 100);
                } else {
                    this.router("/");
                }
            });
        
        // Only track user activity if logged in
        if (auth.currentUser) {
            this.trackUserActivity();
        }
    },
    mounted() {
        if (this.$route.params.page) this.screen = Number(this.$route.params.page);
        this.currentOrientation = window.screen.orientation.type;
        window.screen.orientation.addEventListener('change', this.handleOrientationChangeWrapper);
        this.setupVideoPlayerListeners(); // Call after player is potentially ready
    },
    beforeDestroy() {
        window.screen.orientation.removeEventListener('change', this.handleOrientationChangeWrapper);
        this.cleanupVideoPlayerListeners();
        window.screen.orientation.unlock();
    },
    methods: {
        checkAuth() {
            // Check if user is logged in and store userId if available
            if (auth.currentUser) {
                this.userId = auth.currentUser.uid;
            }
        },
        
        trackUserActivity() {
            auth.onAuthStateChanged((user) => {
                if (!user) return;
                
                this.useremail = user.email;
                db.collection("users")
                    .doc(user.uid)
                    .collection("tracking")
                    .where("id", "==", this.$route.params.id)
                    .get()
                    .then((snap) => {
                        console.log(snap);
                        if (snap.empty) {
                            db.collection("users").doc(user.uid).collection("tracking").add({
                                id: this.$route.params.id,
                                created: new Date().getTime(),
                                type: "challenge",
                            });
                        }
                    });
            });
        },
        
        checkAuthAndProceed(callback) {
            // Check if user is logged in
            if (!auth.currentUser) {
                // Redirect to login page
                this.$router.push('/login');
                return;
            }
            
            // If user is authenticated, proceed with the callback
            callback();
        },
        
        router(name) {
            this.$router.push(name);
        },
        async showInApp(link) {
            await Browser.open({ url: link });
        },
        onPlayerEnded() {
            this.popupOpen = true;
        },
        markComplete() {
            this.btnLoading = true;
            var markComplete = functions.httpsCallable("markComplete");
            markComplete({ pid: this.$route.params.id, type: "challenge" }).then(
                () => {
                    createWebengageEvent({
                        uid: this.userId,
                        eventName: "Challenge Completed",
                        eventData: {
                            added: new Date().getTime(),
                            readableDate: new Date().toLocaleString(),
                            name: this.name,
                        },
                    });
                    this.btnLoading = false;
                    this.screen = 2;
                }
            );
        },
        async shareDialog() {
            await Share.share({
                title: "WitBlox Challenge",
                text:
                    "Hi, are you are good at solving problems? Take this " +
                    this.name +
                    ". Build it, upload its video on WitBlox App & win prizes!",
                url: "https://app.witblox.com/challenge/" + this.$route.params.id,
                dialogTitle: "Share with friends",
            });
        },
        addToCart(p) {
            console.log(p);
            this.cart.push(p.pid);
            this.animation = p.name;
            p.added = true;
            db.collection("shop-products").doc(p.pid).get().then((product) => {
                if (product.exists) {
                    db.collection("users")
                        .doc(auth.currentUser.uid)
                        .collection("cart")
                        .where("product", "==", p.pid).limit(1)
                        .get()
                        .then((snap) => {
                            if (snap.empty) {
                                //not added in cart
                                db.collection("users")
                                    .doc(auth.currentUser.uid)
                                    .collection("cart")
                                    .add({
                                        quantity: 1,
                                        product: p.pid,
                                        added: new Date().getTime(),
                                    })
                                    .then(() => {
                                        this.productsAdded = true;
                                    });
                            } else {
                                //already added in cart
                                db.collection("users")
                                    .doc(auth.currentUser.uid)
                                    .collection("cart")
                                    .doc(snap.docs[0].id).set({
                                        quantity: firestore.FieldValue.increment(1),
                                        product: p.pid,
                                        added: new Date().getTime(),
                                    }, { merge: true })
                                    .then(() => {
                                        this.productsAdded = true;
                                    });
                            }
                        });
                } else console.log("product doesn't exists", p.pid);
                setTimeout(() => {
                    this.animation = "";
                }, 3000);
            }).catch((err) => {
                console.log(err);
                this.animation = "";
            })
        },
        isInCart(sid) {
            if (!sid || !this.shopifyCartCheck.length) return false;
            return this.shopifyCartCheck.includes(parseInt(sid));
        },
        toggleCart(component) {
            if (this.isInCart(component.shopify_data?.variant_id)) {
                this.removeFromShopifyCart(component);
            } else {
                this.addToShopifyCart(component);
            }
        },
        addToShopifyCart(component) {
            this.shopifyCart.push({
                id: component.shopify_data.variant_id,
                quantity: component.qty
            });
            this.shopifyCartCheck.push(component.shopify_data.variant_id);
            
            // Show animation/feedback
            this.animation = component.shopify_data.product_title;
            setTimeout(() => {
                this.animation = '';
            }, 2000);
        },
        removeFromShopifyCart(component) {
            this.shopifyCart = this.shopifyCart.filter(item => item.id !== component.shopify_data.variant_id);
            this.shopifyCartCheck = this.shopifyCartCheck.filter(id => id !== component.shopify_data.variant_id);
        },
        openCart() {
            const baseUrl = `http://witblox.com/cart/`;
            const itemString = this.shopifyCart.map(item => `${item.id}:${item.quantity}`).join(',');
            this.showInApp(baseUrl + itemString + '?storefront=true&app_user_id=' + auth.currentUser.uid);
            //clear cart
            this.shopifyCart = [];
            this.shopifyCartCheck = [];
        },
        getActivePlayer() {
            if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
                return this.$refs.videoPlayer.player;
            }
            return null;
        },
        setupVideoPlayerListeners() {
            this.$nextTick(() => {
                const player = this.getActivePlayer();
                if (player) {
                    // Cleanup if instance changed (less likely here but good practice)
                    if (this.activePlayerInstance && this.activePlayerInstance !== player && this.activePlayerInstance.hasEventListenerForOrientation) {
                        this.activePlayerInstance.off('fullscreenchange', this.handlePlayerFullscreenChange);
                        this.activePlayerInstance.hasEventListenerForOrientation = false;
                    }
                    if (!player.hasEventListenerForOrientation) {
                        player.on('fullscreenchange', this.handlePlayerFullscreenChange);
                        player.hasEventListenerForOrientation = true;
                    }
                    this.activePlayerInstance = player;
                }
            });
        },
        cleanupVideoPlayerListeners() {
            if (this.activePlayerInstance && this.activePlayerInstance.hasEventListenerForOrientation) {
                this.activePlayerInstance.off('fullscreenchange', this.handlePlayerFullscreenChange);
                this.activePlayerInstance.hasEventListenerForOrientation = false;
                this.activePlayerInstance = null;
            }
        },
        handleOrientationChangeWrapper() {
            const newOrientation = window.screen.orientation.type;
            const player = this.getActivePlayer();
            if (!player) return;

            if (newOrientation.includes('landscape')) {
                if (!player.isFullscreen()) {
                    player.requestFullscreen();
                }
            } else if (newOrientation.includes('portrait')) {
                if (player.isFullscreen()) {
                    player.exitFullscreen();
                }
            }
        },
        handlePlayerFullscreenChange() {
            const player = this.getActivePlayer();
            if (!player) return;

            if (player.isFullscreen()) {
                window.screen.orientation.lock('landscape').catch(err => {
                    console.warn('Failed to lock orientation to landscape:', err);
                });
            } else {
                window.screen.orientation.unlock();
            }
        },
    },
    // Watch for screen changes if video player instance might change, though less likely in challenge.vue
    watch: {
      screen(newVal, oldVal) {
        if (newVal !== oldVal) {
          // If screen change implies a new video player instance or options
          this.setupVideoPlayerListeners();
        }
      }
    }
};
</script>
<style scoped>
.plist {
    max-width: 500px;
    margin-bottom: 20px;
}

@media only screen and (min-width: 600px) {
    .video-player.vid2 {
        height: 450px !important;
    }

    .trailerVidBtn .columns {
        max-width: 700px;
        margin: auto;
    }

    .plist {
        max-width: 500px;
        margin-bottom: 10px;
    }
}

@media only screen and (min-width: 600px) {
    .video-player.vid2 {
        height: 450px !important;
    }

    .trailerVidBtn .columns {
        max-width: 700px;
        margin: auto;
    }

    .plist {
        max-width: 500px;
        margin-bottom: 10px;
    }
}

@media only screen and (min-width: 900px) {
    .video-container .desktop-video,
    .video-container .desktop-video-info {
        display: inline;
    }

    .video-container .desktop-video {
        width: 70%;
        height: 100% !important;
        float: left;
    }

    .video-container .desktop-video-info {
        width: 30%;
        height: 100% !important;
        float: right;
        overflow: scroll;
        position: relative;
    }

    .trailerVidBtn {
        width: 30%;
        right: 0;
        left: auto;
    }
}

.nkitinfo {
    padding: 24px;
    background: #1E1E1E;
    color: white;
    border-radius: 25px;
    margin-bottom: 60px;
}

.parts-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.part-card {
    background: #2A2A2A;
    border-radius: 16px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.part-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
}

.part-details {
    flex: 1;
}

.part-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.part-name {
    font-size: 16px;
    font-weight: 600;
}

.cart-toggle-btn {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.check-icon {
    width: 20px;
    height: 20px;
}

.plus-icon {
    width: 20px;
    height: 20px;
}

.part-price {
    font-size: 12px;
    color: #808080;
}

.part-quantity {
    font-size: 12px;
    color: #808080;
}

.alt-components {
    margin-top: 16px;
}
</style>